import React from "react";
import "./homeContent.scss";
import DummyImage from "../../../../assets/images/dummy-image.png";
import SecImage from "../../../../assets/images/sec-image.png";
import FullImage from "../../../../assets/images/full-image.png";
import FullImage1 from "../../../../assets/images/5.png";
import FullImage2 from "../../../../assets/images/6.png";
import FullImage3 from "../../../../assets/images/7.png";
import { NavLink } from "react-router-dom";
export default function HomeContent() {
  return (
    <>
      <div className="home-content-all-alignment">
        <div className="container">
          <div className="grid">
            <div className="grid-items text-style">
              <h1
                className="animate__animated animate__slideInUp wow"
                data-wow-offset="100"
                data-wow-duration="1s"
              >
                Wir bringen den Stein ins Rollen.
              </h1>
              <p
                className="animate__animated animate__slideInUp wow"
                data-wow-offset="100"
                data-wow-duration="1.3s"
              >
                Bereits seit 1993 sind wir professioneller Dienstleister rund um
                das Thema Immobilien mit Standorten in ganz Deutschland.
              </p>
              <span
                className="animate__animated animate__slideInUp wow"
                data-wow-offset="100"
                data-wow-duration="1.5s"
              >
                Gemeinsam mit unseren Kunden entwickeln wir maßgeschneiderte
                Konzepte, die auf jahrelanger Erfahrung, breit gefächertem
                Wissen und den aktuellen Marktgegebenheiten basieren. Unser
                Team, bestehend aus ausgebildeten Fachleuten, bildet sich stetig
                weiter: Mit fundierten Trendeinschätzungen, Daten und Fakten von
                renommierten Kompetenzträgern. So können wir stets bestmöglich
                beraten.
              </span>
            </div>
            <div className="grid-items">
              <div className="image-style">
                <NavLink to="/kontakt">
                  <img
                    className="animate__animated animate__slideInUp wow"
                    data-wow-offset="100"
                    src={DummyImage}
                    alt="DummyImage"
                  />
                </NavLink>
              </div>
            </div>
          </div>
          <div className="sec-grid">
            <div className="sec-grid-items">
              <div className="image-style">
                <NavLink to="/kontakt">
                  <img
                    className="animate__animated animate__slideInUp wow"
                    data-wow-offset="100"
                    src={SecImage}
                    alt="SecImage"
                  />
                </NavLink>
              </div>
            </div>
            <div className="sec-grid-items">
              <div className="text-style">
                <h1
                  className="animate__animated animate__slideInUp wow"
                  data-wow-offset="100"
                  data-wow-duration="1s"
                >
                  Egal, ob Sie eine Immobilie kaufen, verkaufen, mieten oder
                  vermieten möchten - wir stehen Ihnen dabei gern mit Rat und
                  Tat zur Seite.
                </h1>
                <span
                  className="animate__animated animate__slideInUp wow"
                  data-wow-offset="100"
                  data-wow-duration="1.3s"
                >
                  In einem ausführlichen Gespräch definieren wir Ihr Ziel. Dafür
                  beginnen wir mit einer persönlichen Analyse: So können wir
                  sicherstellen, dass wir genau wissen, wo Ihre Prioritäten und
                  Wünsche liegen. Dann skizzieren wir gemeinsam Ihren Weg zum
                  Erfolg. Bei der Beratung haben Sie die Wahl zwischen der
                  erfolgsabhängigen und der provisionsfreien
                  Immobilienvermittlung.
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="three-grid">
            <div className="three-grid-items">
              <div className="lage-image-style">
                <NavLink to="/kontakt">
                  <img src={FullImage} alt="FullImage" />
                </NavLink>
              </div>
              <div className="card-details">
                <h2
                  className="animate__animated animate__fadeInUp wow"
                  data-wow-offset="100"
                >
                  Immobilienvermittlung erfolgsabhängig
                </h2>
                <div className="arrow-grid">
                  <div className="arrow-grid-items">
                    <p
                      className="animate__animated animate__fadeInUp wow"
                      data-wow-offset="100"
                    >
                      Sie wollen vermieten oder verkaufen und brauchen dabei
                      Unterstützung? Wir kümmern uns gern um Ihre Immobilie -
                      vom Inserat bis zur Durchführung der Besichtigungen.
                    </p>
                  </div>
                  <div className="arrow-grid-items">
                    <div className="row-line"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="three-grid-items">
              <div className="lage-image-style">
                <NavLink to="/kontakt">
                  <img src={FullImage1} alt="FullImage1" />
                </NavLink>
              </div>
              <div className="card-details">
                <h2
                  className="animate__animated animate__fadeInUp wow"
                  data-wow-offset="100"
                >
                  Immobilienvermittlung provisionsfrei
                </h2>
                <div className="arrow-grid">
                  <div className="arrow-grid-items">
                    <p
                      className="animate__animated animate__fadeInUp wow"
                      data-wow-offset="100"
                    >
                      Verkaufen oder vermieten Sie ihre Immobilie selbst und
                      sparen Sie so die Provision - wir helfen Ihnen dabei.
                    </p>
                  </div>
                  <div className="arrow-grid-items">
                    <div className="row-line"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="three-grid-items">
              <div className="lage-image-style">
                <NavLink to="/kontakt">
                  <img src={FullImage2} alt="FullImage2" />
                </NavLink>
              </div>
              <div className="card-details">
                <h2
                  className="animate__animated animate__fadeInUp wow"
                  data-wow-offset="100"
                >
                  Property Management Service
                </h2>
                <div className="arrow-grid">
                  <div className="arrow-grid-items">
                    <p
                      className="animate__animated animate__fadeInUp wow"
                      data-wow-offset="100"
                    >
                      Auch im Außendienst für Ihre Wohn- oder Gewerbeimmobilie
                      unterstützen wir Sie gern. So sparen Sie nachhaltig
                      Fixkosten und erhöhen Ihre eigene Flexibilität.
                    </p>
                  </div>
                  <div className="arrow-grid-items">
                    <div className="row-line"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="three-grid-items">
              <div className="lage-image-style">
                <NavLink to="/kontakt">
                  <img src={FullImage3} alt="FullImage3" />
                </NavLink>
              </div>
              <div className="card-details">
                <h2
                  className="animate__animated animate__fadeInUp wow"
                  data-wow-offset="100"
                >
                  Lizenzpartner <br /> Die Win-Win-Lösung
                </h2>
                <div className="arrow-grid">
                  <div className="arrow-grid-items">
                    <p
                      className="animate__animated animate__fadeInUp wow"
                      data-wow-offset="100"
                    >
                      Gemeinsam ist man stärker: Werden Sie jetzt unser nächster
                      Lizenzpartner. Und das ohne zusätzliche Kosten.
                    </p>
                  </div>
                  <div className="arrow-grid-items">
                    <div className="row-line"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
